import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Audience, EGECacheSummaryRequest, EGEEntityRequest, EntityProfileResponse } from '@types';
import { sec } from './security';

const { VITE_API_HOST } = import.meta.env;

// Define a service using a base URL and expected endpoints
export const api = createApi({
  tagTypes: [],
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: VITE_API_HOST,
    prepareHeaders: async (headers) => {
      const access_token = await sec.getAccessTokenSilently()();
      if (access_token) headers.set('Authorization', `Bearer ${access_token}`);
      headers.set('Content-Type', 'application/json');
      return headers;
    }
  }),
  endpoints: (builder) => ({
    getEGEEntities: builder.query<[string, string][], EGEEntityRequest>({
      query: ({ rowboat_table_identifier, bounds }) => {
        return {
          method: 'POST',
          url: `/ege/cache/${rowboat_table_identifier}`,
          headers: {
            Accept: 'application/json'
          },
          body: {
            bounds,
            entities_only: true
          }
        };
      }
    }),
    getEGECacheEntitiesByIds: builder.query<Audience[], EGECacheSummaryRequest>({
      query: ({ rowboat_table_identifier, advertiser_ids }) => {
        return {
          method: 'POST',
          url: `/ege/cache/${rowboat_table_identifier}`,
          headers: {
            Accept: 'application/json'
          },
          body: {
            advertiser_ids: advertiser_ids?.join(';'),
            entities_only: true
          }
        };
      },
      transformResponse: (response: [string, string][]) => {
        // Transform the response array into Audience format
        return response.map(([advertiser_id]) => ({
          advertiser_id,
          n_polygons: 0,
          n_within_sel: 0
        }));
      }
    }),
    getDataCancel: builder.mutation<string[], string>({
      query: (request_identifier) => ({
        method: 'DELETE',
        url: '/',
        params: {
          request_identifier
        }
      })
    }),
    getEntityProfiles: builder.query<EntityProfileResponse, { entity_id: string }>({
      query: ({ entity_id }) => ({
        method: 'GET',
        url: `/entity/${entity_id}/profile/`,
        headers: {
          Accept: 'application/json'
        }
      })
    })
  })
});

export const {
  // \n
  useLazyGetEGEEntitiesQuery,
  useLazyGetEGECacheEntitiesByIdsQuery,
  useGetDataCancelMutation,
  useGetEntityProfilesQuery
} = api;
